import locales from '@/models/locales';

export default {
    head() {
        return {
            htmlAttrs: {
                lang: this.lang
            },
            title: this.$t('app.title'),
            meta: [
                { name: 'description', content: this.$t('app.description') },
            ]
        }
    },

    computed: {
        lang() {
            return this.$store.state.locale;
        }
    },
    watch: {
        lang(locale) {
            this.$root.$i18n.locale = locale;
        }
    },
    created() {
        const de = locales.german.isoCode;
        const en = locales.english.isoCode;
        const cs = locales.czech.isoCode;
        const nl = locales.dutch.isoCode;

        const domainMapping = {
            'gutschein.netto-vorteile.de' : de,
            'netto-total.animod.de' : de,
            'gutschein.animod.de' : de,
            'voucher.animod.com' : en,
            'voucher.animod.cz' : cs,
            'voucher.animod.nl' : nl,
            'stage-gutschein.anilabs.de' : de,
            'stage-voucher.anilabs.de' : en,
            'stage-vouchercz.anilabs.de' : cs,
            'stage-vouchernl.anilabs.de' : nl,
            'dev-gutschein.anilabs.de' : de,
            'dev-voucher.anilabs.de' : en,
            'dev-vouchercz.anilabs.de' : cs,
            'dev-vouchernl.anilabs.de' : nl,
            'smartbox.animod.de' : de,
            'dev-gutschein-kiu.anilabs.de' : de,
            'stage-gutschein-kiu.anilabs.de' : de,
            'gutschein.kurz-in-urlaub.de' : de,
            'einloesen.kurz-in-urlaub.de' : de,
        }
        let lang = domainMapping[location.hostname];
        if (lang === null || lang === undefined) {
            const subdomain = location.hostname.split('.')[0];
            const splitted = subdomain.split('-', 2);
            const isDeployedOnDevOrStage = splitted.length > 1 && (splitted[0] === 'dev' || splitted[0] === 'stage');
            const isDev = ~subdomain.indexOf('localhost') || ~subdomain.indexOf('192') || ~subdomain.indexOf('127.0.0.');
            const fallback = this.$route.query.lang || this.lang || de
            lang = isDev
                ? fallback
                : (domainMapping[subdomain]
                        ? domainMapping[subdomain]
                        : (isDeployedOnDevOrStage
                            ? domainMapping[splitted[1]]
                            : fallback)
                );
        }
        this.$store.dispatch(
            'setLocale', lang
        );
    }
};
